
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.736 9.364a.9.9 0 00-1.272 0L12 13.827 7.536 9.364a.9.9 0 10-1.272 1.272l5.1 5.1a.9.9 0 001.272 0l5.1-5.1a.9.9 0 000-1.272z","fill":"currentColor"}})])
          )
        }
      }
    